// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__29o6f","tab":"ProcedureTabs_tab__2fEQJ"};